import { useMemo } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useSelector } from 'react-redux';

import { quickFilter } from 'features/views/dashboard/statistics/constants';
import {
	getBruttoPeriodTableQuickFilter,
	getBruttoProductionTeamActivities,
} from 'features/views/dashboard/statistics/selectors';
import { equalOrZero } from 'utils/equalOrThreeDashes';
import { currency } from 'utils/formats';
import { joinString } from 'utils/string';

export const BruttoProductionTableBody = () => {
	const bruttoProduction = useSelector(getBruttoProductionTeamActivities);
	const bruttoPeriod = useSelector(getBruttoPeriodTableQuickFilter);

	const bruttoAmount = useMemo(
		() => (brutto) => {
			let amount;
			switch (bruttoPeriod) {
				case quickFilter.TODAY_MINUS_TWO_DAYS:
					amount = brutto?.bruttoAmount;
					break;
				case quickFilter.WEEK:
					amount = brutto?.weekBruttoAmount;
					break;
				case quickFilter.MONTH:
					amount = brutto?.monthBruttoAmount;
					break;
			}

			return currency(amount, null, true);
		},
		[bruttoPeriod],
	);

	const bruttoPolicyCount = useMemo(
		() => (brutto) => {
			let policyCount;
			switch (bruttoPeriod) {
				case quickFilter.TODAY_MINUS_TWO_DAYS:
					policyCount = brutto?.bruttoPolicyCount;
					break;
				case quickFilter.WEEK:
					policyCount = brutto?.weekBruttoPolicyCount;
					break;
				case quickFilter.MONTH:
					policyCount = brutto?.monthBruttoPolicyCount;
					break;
			}

			return equalOrZero(policyCount);
		},
		[bruttoPeriod],
	);

	return bruttoProduction.map((brutto) => (
		<TableRow key={brutto?.login}>
			<TableCell align="left">{joinString(' ', [brutto?.surname, brutto?.firstName])}</TableCell>
			<TableCell align="left">{bruttoAmount(brutto)}</TableCell>
			<TableCell align="center">{bruttoPolicyCount(brutto)}</TableCell>
		</TableRow>
	));
};

export default BruttoProductionTableBody;
